module.exports = __webpack_public_path__ + "img/paysafecard.327f469a.svg";